import { Check } from '@react-apps/design-system';
import { isValidDocument } from '../utils/br-fields';

interface DocumentValidityBadgeProps {
  value: string | null | undefined;
}

/**
 * Indicador puramente visual: bolinha verde com check quando `value` é um
 * CPF ou CNPJ válido (dígitos verificadores batem). Não valida nada no
 * backend nem impede submissão — só ajuda o admin a perceber, olhando pro
 * campo `doc`, se o que está salvo bate com o tipo de documento que parece
 * ser.
 */
export function DocumentValidityBadge({ value }: DocumentValidityBadgeProps) {
  if (!isValidDocument(value)) return null;

  return (
    <span
      className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-400"
      title="Documento válido"
    >
      <Check size="xs" />
    </span>
  );
}
